<!-- ライブ、アーカイブ、スケジュール画面下部に表示する。講座とライブ配信一覧 -->
<script setup lang="ts">
  import PlanTabMenuConfig from "~/consts/PlanTabMenuConfig";
  import { useLiveStore } from "~/stores/LiveStore";
  import { LiveInfo } from "~/entities/LiveInfo";
  import { useHistoryStore } from "~/stores/HistoryStore";

  interface Props {
    planId: string;
    contentsId: string | undefined;
  }
  const props = defineProps<Props>();

  const historyStore = useHistoryStore();
  const liveStore = useLiveStore();
  const liveStreamings = ref<LiveInfo[]>();

  onMounted(async () => {
    // この講座のライブ配信一覧を6個
    try {
      liveStreamings.value = await liveStore.fetchPlanStreamings(1, 6, props.planId, props.contentsId);
    } catch (error: any) {
      // 重要なものではないので取れなくてもエラーにはしない
    }
  });

  const clickAll = () => {
    // コンテンツページのタブをライブに変更して遷移
    historyStore.to({
      path: `/plan/${props.planId}`,
      query: { tab: PlanTabMenuConfig.CONTENT.value, content: "live", showDetail: "true" },
    });
  };
</script>

<template>
  <template v-if="liveStreamings">
    <AtomsContentInformationCard>
      <template #header>
        <MoleculesContentsListTitle icon="live" title="この講座のライブ一覧" :show-all="true" @click-all="clickAll" />
      </template>
      <OrganismsStreamingCardGrid
        :show-header="false"
        :items="liveStreamings"
        empty-message="ライブが提供されていません。"
        :show-featured="false"
      />
    </AtomsContentInformationCard>
  </template>
</template>
